<div *ngIf="title && type" class="d-grid mb-checkout-height">
<div class="row no-gutters px-3 py-3 align-self-start"
     data-cy="mb-checkout-review-info-wrapper">
  <div [ngClass]="[isEditable && linkToEditComponent ? 'col-9' : 'col-12', 'mb-checkout-review-info-title']"
       data-cy="mb-checkout-review-info-title">
    {{ title | mbTranslate }}
  </div>
  <div *ngIf="isEditable && linkToEditComponent"
       class="col-3 text-right"
       data-cy="mb-checkout-review-info-edit">
    <a [routerLink]="linkToEditComponent"
       class="cursor-pointer">
      <img src="../../../../../../assets/icons/svg/edit_pencil.svg"
           alt="Edit information"
           title="Edit information"
           aria-label="Edit information"
           data-cy="mb-checkout-review-info-edit-icon">
    </a>
  </div>
  <div class="col-12 mb-checkout-review-info"
       data-cy="mb-checkout-review-info">

    <ng-container *ngIf="type === infoTypes?.CONTACT_DETAILS && data">
      <div>{{data.title?.name}} {{data.academicDegree?.name}}</div>
      <div>{{data.firstName}} {{data.lastName}}</div>
      <div>{{data.email}}</div>
      <div>{{data.phoneNumber}}</div>
      <div>{{data.jobTitle?.name}}</div>
      <div>{{data.customerNumber}}</div>
    </ng-container>

    <ng-container *ngIf="type === infoTypes?.ADDRESS && data">
        <div *ngIf="data.companyName">{{data?.companyName}}</div>
        <div *ngIf="data.institute">{{data?.institute}}</div>
        <div *ngIf="data.department">{{data?.department}}</div>
        <div *ngIf="data.lab">{{data?.lab}}</div>
        <div *ngIf="data.building">{{data?.building}}</div>
        <div *ngIf="data.streetInformation">{{data?.streetInformation}}</div>

        <ng-container *ngIf="formRegion === checkoutRegions?.EU">
          <div *ngIf="data.postalCode || data.town"> {{data?.postalCode}} {{data?.town}}</div>
        </ng-container>

        <ng-container *ngIf="formRegion === checkoutRegions?.US || formRegion === checkoutRegions?.AU">
          <div *ngIf="data.town || data.postalCode || data.region">{{data?.town}} {{data?.region?.name}}, {{data?.postalCode}}</div>
        </ng-container>

        <ng-container *ngIf="formRegion === checkoutRegions?.UN">
          <div *ngIf="data.town || data.postalCode">{{data?.town}} {{data?.postalCode}}</div>
        </ng-container>

        <div *ngIf="data.country">{{data?.country?.name}}</div>

        <div class="mt-2" *ngIf="data.vatId && formRegion === checkoutRegions.EU">
          {{ vatIdLabelKey | mbTranslate }}: {{ data?.vatId }}
        </div>

        <div class="mt-2" *ngIf="hasSalesTaxExemption && formRegion === checkoutRegions.US">
          {{ salesTaxLabelKey | mbTranslate }} {{ (data?.taxExempt ? 'mbcommon.yes' : 'mbcommon.no') | mbTranslate}}
        </div>

    </ng-container>

    <ng-container *ngIf="type === infoTypes?.SHIPMENT_METHOD">
      <div>{{ 'review.standardDelivery' | mbTranslate }}</div>
    </ng-container>

    <ng-container *ngIf="type === infoTypes?.PAYMENT_METHOD && data">
      <div *ngIf="data?.poPaymentMode">
        {{ 'review.invoice' | mbTranslate }}
      </div>
      <div *ngIf="!data?.poPaymentMode && data?.code === constants.CREDIT_CARD_CODE">
        {{ 'review.creditCard' | mbTranslate }}
      </div>
    </ng-container>

    <ng-container *ngIf="type === infoTypes?.PAYMENT_ADDITIONAL_INFO">
      <div *ngIf="!!data.poNumber">
        {{ poNumberLabelKey | mbTranslate }}
        <div>{{data.poNumber}}</div>
      </div>
    </ng-container>

    <ng-container *ngIf="type === infoTypes?.NOTES && data">
      <span [innerHTML]="data"></span>
    </ng-container>
  </div>
</div>

<div *ngIf="type === infoTypes?.ADDRESS && data" class="mt-2 px-3 py-3 align-self-end">
  <div  class="mb-address-status" *ngIf="(supportingAccountCreation$ | async) && !(supportingGuestCheckout$ | async)">
    <ng-container [ngSwitch]="data?.verificationStatus">
      <ng-container *ngSwitchCase="constants.ADDRESS_VERIFIED_APPROVED_STATUS_03">
        <img src="assets/icons/svg/circle-check-solid.svg"
             class="mb-address-status-icon"
             alt="Address verified"
             title="Address verified"
             aria-label="Address verified"
             data-cy="mb-address-status-icon">
        <span class="pl-1 mb-address-status-text">{{ 'address.status.verified' | mbTranslate }}</span>
      </ng-container>

      <ng-container *ngSwitchCase="constants.ADDRESS_VERIFIED_REJECTED_STATUS_04">
        <img src="assets/icons/svg/circle-xmark-solid.svg"
             class="mb-address-status-icon"
             alt="Address verified"
             title="Address verified"
             aria-label="Address verified"
             data-cy="mb-address-status-icon">
        <span class="pl-1 mb-address-status-text">{{ 'address.status.rejected' | mbTranslate }}</span>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <img src="assets/icons/svg/clock-solid.svg"
             class="mb-address-status-icon"
             alt="Address verified"
             title="Address verified"
             aria-label="Address verified"
             data-cy="mb-address-status-icon">
        <span class="pl-1 mb-address-status-text">{{ 'address.status.inVerification' | mbTranslate }}</span>
      </ng-container>
    </ng-container>
  </div>
</div>
</div>
